'use client';

import { FC, useEffect } from 'react';

import styles from './mobile-nav.module.css';

const MobileNavDomManager: FC<{
  isOpen: boolean;
  onCloseAction: () => void;
}> = ({ isOpen, onCloseAction }) => {
  useEffect(() => {
    function onKeydown(e: KeyboardEvent) {
      if (e.key === 'Escape') {
        onCloseAction();
      }
    }

    const noScrollStyle = styles['no-scroll'];
    if (noScrollStyle) {
      if (isOpen) {
        document.body.classList.add(noScrollStyle);
        document.addEventListener('keydown', onKeydown);
      } else {
        document.body.classList.remove(noScrollStyle);
      }
    }

    return () => {
      document.removeEventListener('keydown', onKeydown);
    };
  }, [isOpen, onCloseAction]);

  return null;
};

export { MobileNavDomManager };
